<template>
    <div class="w-full">
        <slot name="header-content"></slot>
        <slot name="body-content"></slot>
        <ButtonSection
           v-if="showButton"
          :inputValid="inputValid"
          :buttonText="step.buttonText"
          :backButtonText="step.backButtonText"
          :exitButtonText="step.exitButtonText"
          :buttonStyling="buttonStyling"
          v-on:progress="$emit('progress')"
          v-on:back="$emit('back')"
          @hide-modal="$emit('hide-modal')"
        />
    </div>
</template>

<script>
import ButtonSection from './ButtonSection.vue';

export default {
    props: ['step', 'showButton'],
    data() {
        return {
            inputValid: true
        }
    },
    components: {
        ButtonSection
    }
}
</script>
